<template>
<div class="chapter">
<div class="inner_page">
<p class="C453_3"><a id="page_1">PART I</a></p><a id="page_1">
<p class="P1_15">Background</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_PART_I_.vue?4d0482df